import React from "react";
import { useLogin } from "../auth/useLogin";
import { isClient } from "@/utils/browser";

export const getItem = (name: string, defaultValue?: any) => {
  return isClient() && window.localStorage.getItem(name)
    ? JSON.parse(window.localStorage.getItem(name))
    : defaultValue || {};
};

export const setItem = (name: string, value: any) => {
  if (isClient()) {
    if (value) {
      window.localStorage.setItem(name, JSON.stringify(value));
    } else {
      window.localStorage.removeItem(name);
    }
  }
};

export const removeItem = (name: string) => {
  if (isClient()) {
    window.localStorage.removeItem(name);
  }
};

const getDefaultValue = (
  localStorageName: string,
  storageInitialValue: any,
  isUserLoggedIn: boolean
) => {
  if (localStorageName === "user") {
    return isUserLoggedIn ? getItem(localStorageName, storageInitialValue) : {};
  }

  return getItem(localStorageName, storageInitialValue);
};

export const useLocalStorage = (name: string, defaultValue?: any) => {
  const { isUserLoggedIn } = useLogin();

  const foundDefaultValue = getDefaultValue(name, defaultValue, isUserLoggedIn());
  const [value, setValue] = React.useState(foundDefaultValue);

  React.useEffect(() => {
    setItem(name, value);
  }, [name, value]);

  return [value, setValue];
};
